<sui-toolbar>
  @for (button of buttons; track button) {
    @if (button.shouldDisplay === undefined || button.shouldDisplay) {
      <sui-button
        [variant]="button.variant || 'secondary'"
        [leadingIcon]="button.leadingIcon"
        [iconOnly]="!button.label"
        [ariaLabel]="!button.label ? button.tooltip : undefined"
        [suiTooltip]="button.tooltip"
        [loading]="button.loading"
        [disabled]="!button.disabled === undefined || button.disabled"
        (click)="button.action()"
      >
        {{ button.label }}
      </sui-button>
    }
  }
</sui-toolbar>
